import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const generatePdfForInvoice = {
  name: "generatePdfForInvoice" as const,
  input: z.object({ invoiceId: zExt.objectId() }),
  output: z.object({ url: z.string(), filename: z.string() }),
};
